import { Colors } from "@/stitches/types"
import { ExecutionStrategySnapshotStatus, RateConConfirmationStatus } from "@/shared/types"
import {
  executionStrategySnapshotStatusToText,
  getRateConBadgeColors,
  rateConConfirmationStatusToText,
} from "@/shared/utils"

import { Copy, Flex } from "@/shared/components"

interface IRateConStatusBadgeProps {
  status?: ExecutionStrategySnapshotStatus
  confirmationStatus?: RateConConfirmationStatus
  scale?: 8 | 10
}

export const RateConStatusBadge = ({
  status,
  confirmationStatus,
  scale = 10,
}: IRateConStatusBadgeProps) => {
  const showConfirmationLabel =
    confirmationStatus &&
    (status === "RATECON_PENDING_CONFIRMATION" || status === "FINISHED" || status === "CANCELLED")

  const label = showConfirmationLabel
    ? rateConConfirmationStatusToText(confirmationStatus)
    : executionStrategySnapshotStatusToText(status)

  const { color, backgroundColor } = getRateConBadgeColors(status, confirmationStatus)

  return (
    <Flex
      align="center"
      css={{
        height: scale === 8 ? "$32" : "$24",
        borderRadius: "$32",
        padding: scale === 8 ? "$2 $16" : "$2 $8",
        backgroundColor: `$${backgroundColor}` as Colors,
        width: "fit-content",
      }}
    >
      <Copy as="span" scale={scale} color={color} fontWeight="bold">
        {label}
      </Copy>
    </Flex>
  )
}
